// extracted by mini-css-extract-plugin
export default {"mobileTopMenu":"styles_mobileTopMenu__X3eZs","mobileTopMenuLink":"styles_mobileTopMenuLink__HFptz"};